import toast from "react-hot-toast"

export const showFeedbackToast = (variant: "success" | "error", message: string) =>
  toast.custom(
    () => (
      // toast.custom renders the node as-is: the live-region role (status/alert)
      // is needed for assistive tech to announce the only feedback surface.
      <div
        role={variant === "error" ? "alert" : "status"}
        className="flex w-[calc(100vw-32px)] max-w-[432px] items-center gap-3 rounded-xl bg-[#21201c] px-4 py-3 shadow-[0px_16px_40px_0px_rgba(26,29,35,0.16)]"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
          <circle cx="12" cy="12" r="12" fill="white" />
          {variant === "success" ? (
            <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#21201c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          ) : (
            <path d="M8 8l8 8M16 8l-8 8" stroke="#21201c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          )}
        </svg>
        <p className="font-buenosAires text-sm font-bold leading-5 tracking-[-0.28px] text-white">{message}</p>
      </div>
    ),
    { position: "bottom-center", duration: 4000 }
  )
